<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
	  <IndexHeader></IndexHeader>
        <div class="widget-heading d-block">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-flex align-items-center">
              <h4 class="me-3 my-0">Lista walut</h4>
              <Link class="btn btn-outline-primary btn-sm" :href="route('articles.index')">Lista artykułów</Link>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
              <tr>
                <th style="max-width: 100px">Nazwa</th>
                <th>Kurs do PLN</th>
                <th>Data aktualizacji kursu</th>
                <th>Użyta w artykułach</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(currency, index) in currencys" :key="currency.id">
                <td style="max-width: 100px">
                  <input v-if="currency.isEditing" v-model="currency.edited_name" class="form-control"/>
                  <span v-else>{{ currency.name }}</span>
                </td>
				<td>{{ currency.rate }}</td>
				<td>{{ currency.date }}</td>				
                <td>{{ currency.articles_count }}</td>
				
				
                <td>
                  <button v-if="!currency.isEditing" @click="editCurrency(currency)" type="button" class="btn btn-sm btn-warning">
                    Edytuj
                  </button>
                  <button v-if="currency.isEditing" @click="saveCurrency(currency)" type="button" class="btn btn-sm btn-primary">
                    <i class="bi bi-save me-1"></i>Zapisz
                  </button>
                  <button v-if="currency.isEditing" @click="cancelEdit(currency, index)" type="button"
                          class="btn btn-sm btn-outline-primary ms-2">
                    <i class="bi bi-x-circle me-1"></i>Anuluj
                  </button>
                  <button v-if="!currency.isEditing && currency.articles_count < 1" @click="deleteCurrency(currency)" type="button"
                          class="btn btn-sm btn-danger ms-2">Usuń
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <button v-if="!this.isCreatingNewCurrency" class="btn btn-sm btn-outline-success" type="button"
                    @click="createCurrency">
              Utwórz nowy
            </button>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "../../../../Layouts/App.vue";
import {useForm} from "@inertiajs/vue3";
import IndexHeader from "@/Pages/Warehouses/Articles/IndexHeader.vue";

export default {
  components: {
    AppLayout,
	IndexHeader,
  },

  props: {
    currencys: Object,
  },

  data() {
    return {
      isCreatingNewCurrency: false,
      form: useForm({
        name: null,
      }),
    };
  },

  methods: {
    // Włącza tryb edycji dla wybranego wiersza i zapisuje oryginalne wartości
    editCurrency(currency) {
      this.currencys.forEach((u) => {
        this.$set(u, "isEditing", false);
      });
      this.$set(currency, "isEditing", true);
      this.$set(currency, "edited_name", currency.name);
    },

    // Anuluje edycję i przywraca oryginalne wartości
    cancelEdit(currency, index) {
      if (!currency.id) {
        this.currencys.splice(index, 1);
        this.isCreatingNewCurrency = false;
      } else {
        currency.isEditing = false;
        currency.edited_name = currency.name;
      }
    },

    // Zapisuje zmiany do serwera
    saveCurrency(currency) {
      this.form.name = currency.edited_name;

      if (!currency.id) {
        // Jeśli to nowy wiersz, użyj form.post
        this.form.post(route('articles.currencys.store'), {
          preserveScroll: true,
          onSuccess: () => {
            this.$set(currency, "isEditing", false);
          },
        });
      } else {
        // Jeśli to istniejący wiersz, użyj form.put
        this.form.put(route('articles.currencys.update', {articleCurrency: currency.id}), {
          preserveScroll: true,
          onSuccess: () => {
            this.$set(currency, "isEditing", false);
          },
        });
      }
    },

    deleteCurrency(currency) {
      this.form.delete(route('articles.currencys.destroy', {articleCurrency: currency.id}), {
        preserveScroll: true,
      });
    },

    // Dodaje nowy wiersz do tabeli
    createCurrency() {
      const newCurrency = {
        id: null, // Nowy wiersz nie ma jeszcze ID
        name: "",
        isEditing: true,
        edited_name: "",
      };
      this.currencys.push(newCurrency);
      this.isCreatingNewCurrency = true;
    },
  },
};
</script>
